"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var WalletIcon = exports.WalletIcon = function WalletIcon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "white" : _ref$color;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    className: className,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#clip0_201_6365)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M17.5 4.99984H4.16667C3.45083 4.99984 2.77333 4.68984 2.30417 4.16734C2.7625 3.65567 3.42833 3.33317 4.16667 3.33317H19.1667C19.6275 3.33317 20 2.95984 20 2.49984C20 2.03984 19.6275 1.6665 19.1667 1.6665H4.16667C1.86583 1.6665 0 3.53234 0 5.83317V14.1665C0 16.4673 1.86583 18.3332 4.16667 18.3332H17.5C18.8808 18.3332 20 17.214 20 15.8332V7.49984C20 6.119 18.8808 4.99984 17.5 4.99984ZM18.3333 15.8332C18.3333 16.2923 17.96 16.6665 17.5 16.6665H4.16667C2.78833 16.6665 1.66667 15.5448 1.66667 14.1665V5.8315C2.37833 6.364 3.25333 6.6665 4.16667 6.6665H17.5C17.96 6.6665 18.3333 7.04067 18.3333 7.49984V15.8332ZM16.6667 11.6665C16.6667 12.1265 16.2933 12.4998 15.8333 12.4998C15.3733 12.4998 15 12.1265 15 11.6665C15 11.2065 15.3733 10.8332 15.8333 10.8332C16.2933 10.8332 16.6667 11.2065 16.6667 11.6665Z",
        fill: color
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_201_6365",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      })
    })]
  });
};